const buttonClasses = 'bg-neutrals-300 text-neutrals-700';

const buttonHoverClasses = 'hover:bg-neutrals-500 hover:text-white [&:hover_svg]:fill-white';

const buttonIconClasses = 'fill-neutrals-700';

const buttonNeutralClasses = { buttonBlogVariantClasses: [buttonClasses, buttonHoverClasses], buttonIconClasses };

export default buttonNeutralClasses;
